import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';

import { PhoneNumberPipe } from '../shared/phone-number.pipe';
import { CommitmentContainerModule } from './commitment-container';
import { DaysPanelModule } from './days-panel';
import { ExpandablePanelModule } from './expandable-panel';
import { StatPanelModule } from './stat-panel';
import { TooltipComponent } from './tooltip/tooltip.component';

@NgModule({
  declarations: [PhoneNumberPipe, TooltipComponent],
  exports: [
    CalendarModule,
    CommitmentContainerModule,
    ConfirmDialogModule,
    DaysPanelModule,
    ExpandablePanelModule,
    InputTextModule,
    PhoneNumberPipe,
    RadioButtonModule,
    StatPanelModule,
    TooltipComponent,
  ],
  imports: [
    CalendarModule,
    ConfirmDialogModule,
    CommonModule,
    FontAwesomeModule,
    InputTextModule,
    RadioButtonModule,
    TooltipModule,
  ],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(faQuestionCircle);
  }
}
